import $ from 'jquery';

const SELECTORS = {
  basket: '.v2-basket',
  workTypeSelectPage: '#v2-work-type-select-page',
  workPageSelection: '#v2-work-page-selection',
};

const CSS_CLASSES = {
  isOpen: 'is-open',
  hidden: 'hidden',
};

const openBasket = function () {
  $(SELECTORS.basket).addClass(CSS_CLASSES.isOpen);
  $(SELECTORS.workTypeSelectPage).addClass(CSS_CLASSES.hidden);
  $(SELECTORS.workPageSelection).removeClass(CSS_CLASSES.hidden);
};

export default openBasket;
